import styled from 'styled-components';

import { theme } from '../../../../global';

export interface ITimerContainer {
  $isActive?: boolean;
  $isDark?: boolean;
  $active_color?: string;
  $inactive_color?: string;
}

export const TimerClockContainer = styled.div<ITimerContainer>`
  display: flex;
  flex-direction: column;
  width: 100%;
  flex: 1;
  gap: 46px;
  align-items: center;

  ${({ $isActive }) =>
    !$isActive
      ? `
      @media (max-width: 1358px) {
        flex-direction:  row;
        justify-content: space-between;
        align-items: start;
      }
      
    `
      : `
      @media (max-width: 1358px) {
        flex-direction: row;
        justify-content: space-between;
        align-items: start;
      }
    `}
`;

export const TimerTitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  @media (max-width: 1358px) {
    flex-direction: column-reverse;
    max-width: 50%;
    gap: 4px;
  }
`;

export const TimerContainer = styled.div<ITimerContainer>`
  display: flex;
  flex-direction: column;
  gap: 46px;
  align-items: center;
  justify-content: center;
  width: 523px;
  height: 539px;
  padding: 32px 20px;
  border-radius: 32px;
  background-color: ${({ $isActive, $active_color, $inactive_color, $isDark }) =>
    $isDark ? theme.colors.white : $isActive ? $active_color : $inactive_color};
  transition: height 0.1s ease-in-out;

  @media (max-width: 1358px) {
    width: 100%;
    // min-height: ${({ $isActive }) => ($isActive ? '432px' : '194px')};
    // height: ${({ $isActive }) => ($isActive ? '51vh' : '20vh')};
    min-height: 194px;
    height: 20vh;
    gap: 21px;
    justify-content: space-between;
    padding: 20px;

    ${TimerClockContainer} {
    }
  }
`;

export const TimerTitle = styled.span<ITimerContainer>`
  font-weight: 600;
  font-size: 24px;
  line-height: 29.26px;
  text-align: center;
  color: ${({ $isActive }) => ($isActive ? theme.colors.timer_title_active : theme.colors.timer_title)};

  @media (max-width: 1358px) {
    text-align: left;
  }

  @media (max-width: 1358px) {
    font-size: 16px;
    line-height: 19.5px;
  }
`;

export const TimerEditableTitleContainer = styled.div`
  svg {
    margin-left: -32px;
    cursor: pointer;
  }

  @media (max-width: 1358px) {
    width: 100%;
    display: flex;
    align-items: center;
  }
`;

export const TimerEditableTitle = styled.input<ITimerContainer>`
  font-size: 24px;
  font-weight: 600;
  line-height: 24px;
  text-align: center;
  width: 320px;
  height: 52px;
  color: #171717;
  background-color: rgba(241, 245, 249, 0.5);
  padding: 12px;
  border-radius: 12px;

  &::placeholder,
  &::-webkit-input-placeholder {
    font-weight: 400;
    text-align: left;
    color: #a39ebf;
  }

  &:-ms-input-placeholder {
    font-weight: 400;
    text-align: left;
    color: #a39ebf;
  }

  &:focus {
    font-weight: 400;
    text-align: left;
    border: 2px solid #6d87ff;
    color: #070a13;
    background: rgba(241, 245, 249, 1);
  }

  @media (max-width: 1358px) {
    font-size: 20px;
    line-height: 24px;
    height: 42px;
    width: auto;
    max-width: 100%;
  }
`;

export const TimerButtonsContainer = styled.div`
  display: flex;
  flex-grow: 0;
  flex-shrink: 1;
  flex-basis: 15%;
  justify-content: center;
  align-items: center;
  width: 100%;
  position: relative;

  @media (max-width: 1358px) {
    justify-content: left;
    align-items: flex-end;
  }
`;

export const TimerStopButtonContainer = styled.div`
  position: absolute;
  right: 0;

  @media (max-width: 1358px) {
    bottom: 8px;
  }
`;
